import { useState, useEffect, useRef, useCallback } from 'react';
import { TvChannel } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ChannelCardProgramData } from '@/scenarios/channels/types';

import { getChannelCardProgramData } from '../lib/utils/getChannelCardProgramData';

import { useI18n } from './useI18n';

const MS_IN_SECOND = 1000;

export function useCurrentChannelProgramData(channel: TvChannel) {
    const timerIdRef = useRef<number | undefined>();
    const [currentProgramData, setCurrentProgramData] = useState<
        ChannelCardProgramData | undefined
    >(undefined);
    const i18n = useI18n();

    const getCurrentProgramData = useCallback(() => {
        const currentProgram = channel.getCurrentProgram(Date.now());
        return getChannelCardProgramData(currentProgram, i18n);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channel]);

    const refreshCurrentProgramData = useCallback(() => {
        setCurrentProgramData(getCurrentProgramData());
    }, [getCurrentProgramData]);

    useEffect(() => {
        refreshCurrentProgramData();
    }, [refreshCurrentProgramData]);

    useEffect(() => {
        const { currentTime, totalTime } = currentProgramData ?? {};

        if (currentTime === undefined || totalTime === undefined) {
            return;
        }

        timerIdRef.current = window.setTimeout(
            refreshCurrentProgramData,
            (totalTime - currentTime) * MS_IN_SECOND
        );

        return () => {
            clearTimeout(timerIdRef.current);
        };
    }, [timerIdRef, currentProgramData, refreshCurrentProgramData]);

    return {
        currentProgramData,
        refreshCurrentProgramData,
    };
}
